'use client';

import useBus from '../../hooks/use-bus';
import { AppBusEventType } from '../../interfaces/bus-events';
import { useAnalytics } from '../../hooks/use-analytics';
import { requestOverwolfLogin } from '../../services/overwolf/overwolf-store.service';

// -----------------------------------------------------------------------------
// Login flow when embedded in the Overwolf client. We don't render a form — the
// client owns the login UI. On a login request we ask the shell to open its
// native in-app login overlay; the resulting login-state change is picked up by
// UserProfileProvider via the profile-changed event.
export const OverwolfLogin = (): JSX.Element => {
  const analytics = useAnalytics();

  useBus(AppBusEventType.App.ShowLoginModal, (event) => {
    if (!event?.data?.show) {
      return;
    }

    analytics.track('appstore_login_view', {
      source: event?.data?.source || 'unknown',
    });

    requestOverwolfLogin('Dark');
  });

  return <></>;
};

export default OverwolfLogin;
